import React from "react";
import "./HomeComponentTwo.scss"
import Button from "../Button/Button";
import { sortByOrderAscending } from "../../helper/helper";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedCategory } from "../../../../../../../redux/companyDataSlice";
import { useHistory } from "react-router";
const HomeComponentTwo = ({ components }) => {
    const categories = useSelector((state) => state.companyData.categories)
    const dispatch = useDispatch()
    const history = useHistory()
    const images = [
        "https://i.pinimg.com/736x/15/8f/dd/158fdd965744b4a38eef2c61dfcc5b35.jpg",
        "https://i.pinimg.com/736x/9e/ab/19/9eab19d75aed939b565b1d72536af48e.jpg",
        "https://i.pinimg.com/736x/37/1f/bd/371fbd6574c669620def6d2125b7b014.jpg",
        "https://i.pinimg.com/736x/fb/5e/aa/fb5eaafed6a7f5c5dad0c7908de99e35.jpg",
    ]

    const getComponents = (component) => {
        switch (component.ID) {
            case "curated-collection-header":
                return <div className="details-header">{component.Props.content}</div>

            case "curated-collection-list":
                return <div className="collection-row-one">
                    {categories.slice(0, 4).map((coll, key) => {
                        return (
                            <div className="item-collection" style={{
                                backgroundImage:
                                    `linear-gradient(
                                        to bottom,
                                        rgba(0, 0, 0, 0) 0%, 
                                        rgba(0, 0, 0, 0.8) 100%
                                      ), url(${images[key]})`
                            }} key={key}>
                                <div className="title-text">{coll?.ProductCategory?.Category.toLowerCase()}</div>
                                <div className="button-container">
                                    <Button text="SHOP NOW" invert
                                        onClick={() => {
                                            dispatch(setSelectedCategory(coll))
                                            history.push("/products/category")
                                        }} /></div>
                            </div>
                        )
                    })}

                </div>
            default:
                return <div />
        }

    }
    return (
        <div className="HomeComponentTwo">
            {sortByOrderAscending(components).map((component) => {
                return getComponents(component)
            })}

        </div>
    )

}
export default HomeComponentTwo